import {
  Box,
  Button,
  Flex,
  HStack,
  Icon,
  useToken,
  VStack,
} from "@chakra-ui/react"
import { HomeEmenuFeatures } from "@data/features"
import NextLink from "next/link"
import { useTranslations } from "next-intl"

export default function HomeFeatures() {
  const [brandSecondary, gray50] = useToken("colors", [
    "brand.secondary",
    "gray.50",
  ])
  const t = useTranslations("home.features")
  return (
    <>
      <HStack
        spacing={{ base: 8, md: 24 }}
        overflowX={"scroll"}
        flexWrap={"nowrap"}
        alignItems={"flex-start"}
        mt={50}
        pb={10}
        sx={{
          scrollbarColor: `${brandSecondary} transparent`,
        }}
        css={{
          "&::-webkit-scrollbar": {
            height: "10px",
          },
          "&::-webkit-scrollbar-track": {
            height: "10px",
            backgroundColor: gray50,
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: brandSecondary,
            borderRadius: "6px",
          },
        }}
      >
        {HomeEmenuFeatures.map((feature, index) => (
          <VStack
            key={index}
            spacing={6}
          >
            <Flex
              width={{ base: 24, md: 160 }}
              height={{ base: 24, md: 160 }}
              alignItems={"center"}
              justifyContent={"center"}
              borderRadius={"full"}
              borderWidth={2}
              borderColor={"gray.200"}
              mx={10}
            >
              <Icon
                as={feature.icon}
                color={"brand.primary"}
                w={{ base: 12, md: 20 }}
                h={{ base: 12, md: 20 }}
              />
            </Flex>
            <Box
              textAlign={"center"}
              color={"brand.black"}
              paddingBottom={10}
              fontSize={"sm"}
            >
              {t(feature.description)}
            </Box>
          </VStack>
        ))}
      </HStack>
      <Flex
        justifyContent={"center"}
        mt={20}
      >
        <Button
          as={NextLink}
          href={`/features`}
          size={"lg"}
          variant={"outline"}
          color={"brand.primary"}
          borderColor={"brand.primary"}
          fontWeight={"500"}
        >
          {t("see_more_features")}
        </Button>
      </Flex>
    </>
  )
}
